<div class="box full">
    <div class="innerBox">
        <div class="tableContainer">
            <div class="tableHeadline">
                <h3 class="form-headline">{{title}}</h3>
            </div>
            <div class="treeContainer">
                <form [formGroup]="form" [hidden]="!enableSearch">
                    <common-form-field label="{{i18n.searchFieldLabel}}">
                        <common-form-input formControlName="searchName">
                        </common-form-input>
                    </common-form-field>
                </form>
                <div class="controlWrapper withIcons">
                    <div class="genericControl">
                        <ng-content></ng-content>
                    </div>
                </div>
            </div>
            <div class="table-wrapper">
                <div class="scrollable">
                    <table class="spp-table">
                        <thead>
                            <tr class="tr noHover">
                                <th class="th control"><span></span></th>
                                <th class="th control"><span></span></th>
                                <th *ngIf="hasEditIcon" class="th control"><span></span></th>
                                <th class="th"><span>{{columnTitle}}</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="tr" *ngFor="let node of viewTree">
                                <td class="td vd" *ngIf="node.hasChildren && node.children?.length>0" (click)="toggle(node)">
                                    <button *ngIf="node.hasChildren && node.children?.length>0" type="button"
                                            [ngClass]="{'icon-open': !node.expanded,'icon-close':node.expanded}"
                                            ibtn ibtnSmall ibtnUnboxed
                                            [title]="!node.expanded ? i18n.unfold : i18n.fold "></button>
                                </td>
                                <td class="td" *ngIf="!node.hasChildren || !node.children?.length>0"></td>

                                <td class="td" *ngIf="node.hasAccess && !node.hideAdd" (click)="onNewNode(node)">
                                    <button type="button" ibtn="new" ibtnSmall ibtnUnboxed
                                            (click)="onNewNode(node)" title="{{i18n.add}}"></button>
                                </td>
                                <td class="td" *ngIf="!node.hasAccess || node.hideAdd">
                                    <span [ngStyle]="{'margin-right': '35px'}" ></span>
                                </td>

                                <td class="td" *ngIf="hasEditIcon && node.hasAccess && !node.hideEdit" (click)="onEditNode(node)">
                                    <button type="button" ibtn="edit" ibtnSmall ibtnUnboxed
                                            (click)="onEditNode(node)" title="{{i18n.edit}}"></button>
                                </td>
                                <td class="td" *ngIf="hasEditIcon && (!node.hasAccess || node.hideEdit)">
                                    <span [ngStyle]="{'margin-right': '35px'}" ></span>
                                </td>

                                <td class="td" (click)="onNodeSelected(node)" [title]="node.hasAccess ? i18n.showDetails : i18n.noAccess ">
                                    <span [ngClass]="{disabled:!node.hasAccess}">
                                        <button type="button" [ngStyle]="node.style"
                                                [ngClass]="icon" ibtn ibtnSmall ibtnUnboxed class="no-hover"></button>
                                        {{node.name}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
